module.exports = __webpack_public_path__ + "static/media/AddHomework.7e2d2090.svg";